import React, { useContext, useEffect } from "react";
import phone from "../../images/phone.png";
import textbox from "../../images/textbox.png";
import Moment from "react-moment";
import MainContext from "../../state/main/mainContext";
import ReactGA from 'react-ga';

const Results = () => {
  const mainContext = useContext(MainContext);
  const { studentData, iframe } = mainContext;

  const chatUrl = 'https://c1.websitealive.com/11022/operator/guest/gDefault_v2.asp?cframe=login&chattype=normal&groupid=11022&websiteid=2002&departmentid=14230&sessionid_=&iniframe=&ppc_id=&autostart=&proactiveid=&req_router_type=&text2chat_info=&loginname=&loginnamelast=&loginemail=&loginphone=&infocapture_ids=&infocapture_values=&dl=https%3A%2F%2Fgraduationtracker%2Eazurewebsites%2Enet%2F&loginquestion='

  const openChat = () => {
    if (!iframe) {
      window.wsa_open_chat(1608,14230,0,18198);
    }
    return
  }

  useEffect(() => {
ReactGA.pageview(window.location.pathname); 
  }, [])
  return (
    <section id="results">
      <div className="container">
        <div className="top">
          <h2>
            Your <br /> Results
          </h2>
          <p>
            At Learn4Life, every day is Graduation Day! Based on your input, you
            could expect to graduate from a Learn4Life school some time between
          </p>
        </div>
        <h3 className="dates">
          <Moment format="MMMM DD, YYYY">{studentData.date1}</Moment> - <br/>
          <Moment format="MMMM DD, YYYY">{studentData.date2}</Moment>
        </h3>
       {iframe ? (<a href="#" id="learn-more" style={{marginTop: '2rem', marginBottom: '-2rem'}} className="btn btn-white" onClick={() => window.parent.postMessage("close modal","https://stagingavahs.wpengine.com/")}>
          Call or Chat with Us
        </a>) : <div className="follow-btns">
          <div>
          <a href="tel:18773605327" className="btn btn-white">
            <img id="phone" src={phone} alt="" />
          </a >
          <p>Call Us</p>
          </div>
          <div>
          <a class="chat-us" target="_self" onClick={openChat} href={`${iframe ? chatUrl : 'javascript:void(0)'}`} className="btn btn-white">
            <img id="textbox" src={textbox} alt="" />
          </a >
          <p>Chat</p>
          </div>
        </div>}
        <div className="bottom">
          <h2>
            It’s time to <br /> change your <br /> story! FREE!
          </h2>
          <p>To get started today, click above to call or chat with us.</p>
        </div>
        <a href={`${iframe ? '/?iframe="yes' : 'https://learn4life.org/'}`} id="learn-more" className="btn btn-white">
          {iframe ? 'Calculate Again' : 'Learn More'}
        </a>
        <p id="bottom-p">
          *These dates are for illustrative purposes only. Actual graduation
          date will vary, depending on the personalized plan you and your
          teacher create. Not everyone is eligible to enroll. Please contact us
          to ensure you meet state mandated age and residency requirements.
        </p>
      </div>
    </section>
  );
};

export default Results;
